import { colors } from '@bonitour/components'

export const colorCycle = [
  colors.indigo2, colors.green7, colors.blue4, colors.orange4, colors.red7,
  colors.indigo4, colors.brown1, colors.green8, colors.indigo5, colors.green9,
  colors.green10, colors.purple4, colors.brown2, colors.green11, colors.yellow4
]
